/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type TeamRankingQueryQueryVariables = Exact<{
  teamId: number;
  clubId: number;
}>;

export type TeamRankingQueryQuery = {
  __typename: 'query_root';
  teams_team_detail_by_pk:
    | Array<{
        __typename: 'teams_team_detail';
        id: number;
        team_id: number | undefined;
        name_in_club: string | undefined;
        club:
          | Array<{
              __typename: 'clubs_club_detail';
              id: number;
              sport:
                | {
                    __typename: 'clubs_sport';
                    id: number;
                    slug: string | undefined;
                  }
                | undefined;
            }>
          | undefined;
        team_in_season:
          | {
              __typename: 'teams_team_in_season';
              id: number;
              last_competition_with_ranking:
                | Array<{
                    __typename: 'competitions_competition_detail';
                    id: number;
                    name: string | undefined;
                    rankings:
                      | Array<{
                          __typename: 'competitions_ranking_detail';
                          id: number;
                          name_in_competition: string | undefined;
                          pts: unknown;
                          rank: unknown;
                          even: unknown;
                          ga: unknown;
                          gd: unknown;
                          gf: unknown;
                          logo: string | undefined;
                          lost: unknown;
                          played: unknown;
                          team_id: number | undefined;
                          team_in_season_id: number | undefined;
                          win: unknown;
                          club_id: number | undefined;
                        }>
                      | undefined;
                  }>
                | undefined;
            }
          | undefined;
      }>
    | undefined;
};

export const TeamRankingQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TeamRankingQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clubId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teams_team_detail_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'args' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'club_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'clubId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'team_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name_in_club' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'club' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'args' },
                      value: { kind: 'ObjectValue', fields: [] },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sport' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team_in_season' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'last_competition_with_ranking',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rankings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'name_in_competition',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pts' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'even' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ga' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gd' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gf' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logo' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lost' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'played' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'team_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'team_in_season_id',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'win' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'club_id' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TeamRankingQueryQuery,
  TeamRankingQueryQueryVariables
>;
